import React from 'react';
import { useState } from "react";
import { database } from '../../firebaseConfig'
import { collection, addDoc, deleteDoc, doc } from "firebase/firestore";
import AdminDashboard from "../../UserPanel/Shared/AdminDashboard/AdminDashboard";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import "./ManagerHomeBanner.css"

const ManageHomeBanner = (props) => {
    const collectionRef = collection(database, "homeBanner");

    const [image, setImage] = useState('');


    const handleSubmit = () => {
        if (image) {
            addDoc(collectionRef, {
                img: image

            }).then(() => {
                document.getElementById('image').value = '';
                alert('image is uploaded')
            }).catch((error) => {
                alert(error.message);

            })
        }
        else {
            alert("no Image Found")
        }


    }

    const handleDelete = (id) => {

        console.log(id);
        deleteDoc(doc(database, "homeBanner", id)).then(() => {
            alert("image deleted")
        })


    }







    const convert2base64 = e => {
        const file = e.target.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            setImage(reader.result.toString());
        }
        reader.readAsDataURL(file);
    }
    return (
        <div className="homeBannerBack">
            <AdminDashboard></AdminDashboard>
            <div className="mt-5 submitBox container">

                <input className="" id="image" type="file" onChange={e => convert2base64(e)} />
                <button className="btn btn-success" onClick={handleSubmit}>Submit</button>
            </div>
            <br />
            <br />
            <br />


            <Container>
                <Row>
                    {props.banner.map((item) => (
                        <Col xs={12} md={6} lg={3} className="logoBox" key={item.id}>
                            <img width="120px" height="120px" src={item.img} alt="" />
                            <button className="btn btn-danger m-5" onClick={() => handleDelete(item.id)}>Delete</button>
                        </Col>
                    ))}
                </Row>
            </Container>



        </div >





    );
}

export default ManageHomeBanner;

